// api/services/customers.ts
import { handleRequest } from '@/api';
import type { Customer } from '@/types/customers';

interface FetchOpts {
    signal?: AbortSignal;
}

/** Alias for backwards compatibility with code that imported CustomerResponse */
export type CustomerResponse = Customer;

interface CustomerPayload {
    customer_name: string;
    agency_id?: number | null;
    country_code: string;
    country_list?: string[];
    currency_code?: string;
    is_active?: boolean;
}

interface CustomerUpdatePayload extends CustomerPayload {
    id: number;
}

interface CustomerOperationResponse {
    message: string;
    customer_id: number;
}

export const getAssociatedCustomers = (opts: FetchOpts = {}): Promise<CustomerResponse[]> =>
    handleRequest<CustomerResponse[]>('get', '/customers/?associated=true', opts);

export const getUnassociatedCustomers = (opts: FetchOpts = {}): Promise<CustomerResponse[]> =>
    handleRequest<CustomerResponse[]>('get', '/customers/?associated=false', opts);

/** Superuser only — returns all customers with no association filter */
export const getAllCustomers = (): Promise<CustomerResponse[]> =>
    handleRequest<CustomerResponse[]>('get', '/customers/');

export const createCustomer = (customerData: CustomerPayload): Promise<CustomerOperationResponse> =>
    handleRequest<CustomerOperationResponse>('post', '/customers/', customerData, 'Customer created successfully!');

export const updateCustomer = (payload: CustomerUpdatePayload): Promise<CustomerOperationResponse> =>
    handleRequest<CustomerOperationResponse>(
        'put',
        `/customers/${payload.id}`,
        payload,
        'Customer updated successfully'
    );

export const deleteCustomer = (customerId: number): Promise<void> =>
    handleRequest<void>('delete', `/customers/${customerId}`, {}, 'Customer deleted successfully!');

export const associateCustomer = (selectedCustomer: { id: number }): Promise<void> =>
    handleRequest<void>('post', `/customers/${selectedCustomer.id}/associate`, {}, 'Customer associated successfully!');
